module.exports = __webpack_public_path__ + "static/box-1973c931692386025a7c92db57d5ea07.gif";